import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDefectDasboard',
  template: `
    <button *ngIf="params.node.data.Status ==='Closed' && params.node.data.TotalDefectActions === 0" tooltipPosition="top"  [pTooltip]="noActionsTooltip"
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
    >
      <mat-icon>remove_red_eye</mat-icon>
    </button>
    <button style="background-color: #6FBABA;"  [pTooltip]="viewActionsTooltip"
      mat-mini-fab tooltipPosition="top"
      *ngIf="params.node.data.TotalDefectActions > 0"
      (click)="onClick($event)"
    >
    <mat-icon>remove_red_eye</mat-icon>
    </button>
  `,
  styles: [
    `
      .add-icon {
        background: cornflowerblue;
      }
      button{
        height: 35px;
        width: 35px;
        display: inline-flex;
    align-items: center;
    justify-content: center;
        margin: 0 3px;

      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererDefectDashBoard
  implements ICellRendererAngularComp, OnDestroy {
  clicked = false;
  params: any;

  /** i18n section for the host page, supplied via cellRendererParams.page */
  private page = 'NewDefectDashboard';
  public viewActionsTooltip = '';
  public noActionsTooltip = '';

  constructor(public translate: TranslateService) {}

  refresh(params: any): boolean {
    // Returning false tells ag-Grid to destroy and rebuild this cell, which
    // re-runs agInit and re-resolves the tooltips. It must not throw: the page
    // calls refreshCells({ force: true }) when the language changes.
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    if (params && params.page) {
      this.page = params.page;
    }
    this.viewActionsTooltip = this.t('ViewActions', 'View Actions');
    this.noActionsTooltip = this.t('ActionsNotAvailable', 'Actions not available');
  }

  /** langObj (via cellRendererParams.getLangObj) -> "<page>.<key>" -> flat key -> English. */
  private t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    for (const candidate of [`${this.page}.${key}`, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }
  onClick($event: any): any {
    const spec = $event.target.className;
    if (
      spec !== 'Delete' &&
      spec !== 'close'
    ) {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data,
          // ...something
        };
        this.params.onClick(params);
      }
    } else {
      this.clicked = true;
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
